module.exports = __webpack_public_path__ + "/img/Sot223-Custom-Footprint-bBJ5Uv.svg";